
    import Vue from 'vue';
    import saveEmissionService from '../../../shared/services/saveEmission-service';
    import getSelectedProducerService from '../../../shared/services/selectedProducer-service';
    export default Vue.extend({
        el: '#step2',
        name: 'TabTwo',
        data() {
            return {
                modeloMovilidad: null,
                marcaMovilidad: null,
                SelectedNotebook: null,
                SelectedCelular: null,
                SelectedTablet: null,
                SelectedAuricular: null,
                equipment: [],
                validNotebook: false,
                validAuricular: false,
                validCelular: false,
                validTablet: false,
                DataPlan: null,
                planDescription: null,
                primerCuota: null,
                vehicleSelected: null,
                coberturasAmparo: [],
                producerId: null,
                stepOneData: null,
                organizer: null,
                DataVehicle: null,
                amparoTypeDetails: [],
                vehicleId: null,
                amparoEquipment: [],
                insuredGoodDetails: null,
                marcaMovilidadInvalid: false,
                clientCode: "0",
                originId: 4,
                producerDataLoaded: false,
                referente: null,
                medium: null,
            }
        },
        methods: {
            validate: function (config, direction) {
                var timeStart = new Date();
                sessionStorage.setItem("TimeStart", JSON.stringify(timeStart));
                var formIsValid = NF.Validation.Form.validate('#form2Client');
                if (!formIsValid) {
                    return formIsValid;
                }
                if (direction != "backward" && this.marcaMovilidad != null) {
                    this.SaveEmission();
                }
                else {
                    if (this.marcaMovilidad == null) {
                        const eventData = {
                            'product': 'movilidad',
                            'event': 'errorUsuario',
                            'paso': 'cotizador-movilidad-datos-vehiculo',
                            'referente': this.referente,
                            'medio': this.medium
                        };

                        window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                        window.globalThis.dataLayer.push(eventData);

                        const customWindow = window as typeof window & {
                            _qsie?: Array<typeof eventData>;
                        };

                        customWindow._qsie ??= [];
                        customWindow._qsie.push(eventData);

                        this.marcaMovilidadInvalid = true;
                        return false;
                    }
                    return formIsValid;
                }
            },

            validMarca: function () {
                this.marcaMovilidad != null ? this.marcaMovilidadInvalid = false : true;
            },

            showRuletaErrorModal(show) {
                if (show) {
                    this.$refs.modalErrorRuleta.open();
                }
                else {
                    this.$refs.modalErrorRuleta.close();
                }
            },

            retryEmission() {
                sessionStorage.removeItem("producerData");
                this.producerDataLoaded = false;
                this.showRuletaErrorModal(false);
                this.startProducerDataTask()
                this.SaveEmission();
            },

            waitForProducerData() {
                return new Promise((resolve, reject) => {
                    const timeout = setTimeout(() => {
                        this.showRuletaErrorModal(true);
                        reject(new Error("Timeout: Ruleta respondió en más de 1 minuto"));
                    }, 60000); // espera 1 minuto y tira timeout de ruleta

                    const checkProducerDataLoaded = async () => {
                        while (!this.producerDataLoaded) {
                            await new Promise(resolve => setTimeout(resolve, 200)); // Espera 200ms
                        }
                        clearTimeout(timeout); // Limpia el timeout si los datos se cargan
                        resolve(true);
                    };

                    checkProducerDataLoaded();
                });
            },


            startProducerDataTask() {
                return new Promise((resolve, reject) => {
                    this.stepOneData = JSON.parse(sessionStorage.getItem("stepOneData"));
                    if (this.stepOneData != null) {
                        getSelectedProducerService.GetSelectedProducer(
                            this.clientCode,
                            this.stepOneData.localityId,
                            0,
                            this.originId,
                            this.stepOneData.zipCode
                        ).then(producerData => {
                            sessionStorage.setItem("producerData", JSON.stringify(producerData));
                            this.producerDataLoaded = true;
                            resolve(true);
                        }).catch(error => {
                            this.showRuletaErrorModal(true);
                            reject(error);
                        });
                    }
                });
            },

            async SaveEmission() {
                try {
                    await this.waitForProducerData();
                    var DataVehicle = JSON.parse(sessionStorage.getItem("DataVehicle"));
                    DataVehicle = { ...DataVehicle, vehicleBrand: this.marcaMovilidad }
                    sessionStorage.setItem("DataVehicle", JSON.stringify(DataVehicle));
                    const producerData = JSON.parse(sessionStorage.getItem("producerData"));
                    if (!producerData) {
                        NF.UI.Page.unblock();
                        this.showRuletaErrorModal(true);
                        return;
                    }
                    this.stepOneData = JSON.parse(sessionStorage.getItem("stepOneData"));

                    //Inicio de creacion de objeto AmparoTypeDetails
                    this.amparoTypeDetails = [];
                    var amparoTypeRoboMovilidadId = this.coberturasAmparo.find(o => o.amparoTypesDescription == "Robo Movilidad").amparoTypes;
                    var insuredGoodId = this.vehicleId;
                    var amparoMobility = {
                        amparoTypeId: amparoTypeRoboMovilidadId,
                        amparoTypeDescription: "Robo Movilidad Urbana",
                        insuredGoodDetails: [{
                            insuredGoodId: insuredGoodId,
                            insuredGoodDescription: this.vehicleSelected,
                            brandDescription: this.marcaMovilidad,
                            modelDescription: this.modeloMovilidad
                        }]
                    };
                    this.amparoTypeDetails.push(amparoMobility);
                    if (this.validNotebook || this.validCelular || this.validTablet || this.validAuricular) {
                        var amparoTypeEquipmentId = this.coberturasAmparo.find(o => o.amparoTypesDescription == "Equipos Electrónicos").amparoTypes
                        const equipmentTypes = [
                            { valid: this.validNotebook, id: 1, description: "Notebook" },
                            { valid: this.validCelular, id: 2, description: "Celular" },
                            { valid: this.validTablet, id: 3, description: "Tablet" },
                            { valid: this.validAuricular, id: 4, description: "Auriculares" }
                        ];
                        this.amparoEquipment = {
                            amparoTypeId: amparoTypeEquipmentId,
                            amparoTypeDescription: "Equipos Electrónicos",
                            insuredGoodDetails: equipmentTypes
                                .filter(item => item.valid)
                                .map(item => ({
                                    insuredGoodId: item.id,
                                    insuredGoodDescription: item.description
                                }))
                        };
                        this.amparoTypeDetails.push(this.amparoEquipment);
                    }
                    //Fin de creacion de objeto AmparoTypeDetails
                    //Se consume el Servicio de SaveEmission con los datos correspondientes
                    var birthDay = this.stepOneData.birthDay;
                    if (birthDay == null || birthDay == undefined) {
                        birthDay = "01/01/1900"
                    }
                    var dateFormat = new Date(birthDay);
                    var JsonEmissionData = JSON.stringify({
                        birthday: dateFormat,
                        cityCode: parseInt(this.stepOneData.localityId),
                        clientAddress: {
                            department: this.stepOneData.numDept == null ? "" : this.stepOneData.numDept.toString(),
                            floor: parseInt(this.stepOneData.piso == null ? 0 : this.stepOneData.piso),
                            streetName: this.stepOneData.streetName == null ? "" : this.stepOneData.streetName.toString(),
                            streetNumber: this.stepOneData.numDom == null ? "" : this.stepOneData.numDom.toString(),
                        },
                        clientFirstName: (this.stepOneData.firstName != null && this.stepOneData.firstName != "") ? this.stepOneData.firstName.toString() : "",
                        clientLastName: (this.stepOneData.lastName != null && this.stepOneData.lastName != "") ? this.stepOneData.lastName.toString() : " ",
                        documentNumber: parseInt(this.stepOneData.documentNumber),
                        documentType: this.stepOneData.documentType.id.trim(),
                        email: this.stepOneData.email != null ? this.stepOneData.email.toString() : null,
                        phones: [{
                            areaCode: this.stepOneData.telephone == null ? null : parseInt(this.stepOneData.areaCode),
                            countryCode: this.stepOneData.telephone == null ? null : parseInt(this.stepOneData.telephone[0].countryCode),
                            order: this.stepOneData.telephone == null ? null : parseInt(this.stepOneData.telephone[0].order),
                            phoneNumber: this.stepOneData.telephone == null ? "" : this.stepOneData.telephone.toString(),
                            phoneType: this.stepOneData.telephone == null ? null : parseInt(this.stepOneData.telephone[0].phoneType)
                        }],
                        zipCode: this.stepOneData.zipCode,
                        amparoTypeDetails: this.amparoTypeDetails,
                    });

                    const response = await saveEmissionService.TheftSaveEmission(JsonEmissionData);

                    if (response.validationResult.errorMessage === "Los datos para la emisión se guardaron correctamente") {
                        NF.UI.Page.block();
                        this.Bus.$emit('redirectSummary');
                        return true;
                    } else {
                        this.showRuletaErrorModal(true);
                    }
                }
                catch (error) {
                    NF.UI.Page.unblock();
                    this.showRuletaErrorModal(true);
                }
            },
            getInitData() {
                this.Bus.$on('get-step-two-data', () => this.Bus.$emit('step-two-data', this.$data))
                var ProductData = JSON.parse(sessionStorage.getItem("ProductDataSelected"));
                var planData = JSON.parse(sessionStorage.getItem("PlanSelected"));
                if (ProductData != null) {
                    this.vehicleSelected = ProductData.productDescription;
                    this.vehicleId = ProductData.code;
                };
                if (planData != null) {
                    this.coberturasAmparo = planData.amparoTheftOptions;
                };
                this.startProducerDataTask();
            }
        },
        watch: {
            //!!newVal convierte newVal en un valor booleano,
            //de manera que this.validCelular recibirá true si newVal es un valor "verdadero" y false si es "falso".
            SelectedNotebook(newVal) {
                return this.validNotebook = !!newVal;
            },
            SelectedAuricular(newVal) {
                return this.validAuricular = !!newVal;
            },
            SelectedCelular(newVal) {
                return this.validCelular = !!newVal;
            },
            SelectedTablet(newVal) {
                return this.validTablet = !!newVal;
            }
        },
        mounted() {
            var referente = sessionStorage.getItem("Referente");
            referente == 'null' || referente == null ? this.referente = null : this.referente = referente;
            var medium = sessionStorage.getItem("Medium");
            medium == 'null' || medium == null ? this.medium = 'organic' : this.medium = medium;

            this.getInitData();
        },
    });
